import { render, staticRenderFns } from "./OnboardingStatusView.vue?vue&type=template&id=472eaddd&"
import script from "./OnboardingStatusView.vue?vue&type=script&lang=js&"
export * from "./OnboardingStatusView.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingStatusView.vue?vue&type=style&index=0&id=472eaddd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports